import { Navigate, useParams } from "react-router-dom";

export const PatientFacesheetRedirect = () => {
  const { id } = useParams();
  return (
    <Navigate to={`/ehr/patients/${id}/charting-dashboard/facesheet`} replace />
  );
};
